import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { Format, LocalizationUtils } from '@core/services/utils/localization.utils';

export type ModeTimeTakeAway = 'date' | 'time' | 'full';

@Pipe({
  name: 'takeAwayTime'
})
export class TakeAwayTimePipe implements PipeTransform {
  private readonly matrixModeToFormat: Record<string, Format> = {
    ['date']: 'dateListFormat',
    ['time']: 'timeFormat',
    ['full']: 'dateTimeListFormat',
  }

  constructor(private localizationUtils: LocalizationUtils) {
  }

  transform(value: string | null | undefined, mode: ModeTimeTakeAway): string {
    if (!value) return '';

    const dateObj: Date = new Date(value);
    if (isNaN(dateObj.getTime())) return '';

    const now: Date = new Date();
    const isToday: boolean =
      dateObj.getFullYear() === now.getFullYear() &&
      dateObj.getMonth() === now.getMonth() &&
      dateObj.getDate() === now.getDate();

    if (isToday) {
      if (mode === 'date') return '';
      if (mode === 'time' || mode === 'full') return this.localizationUtils.getFormattedDate(value, 'timeFormat');
    }

    return Boolean(this.matrixModeToFormat[mode])
      ? this.localizationUtils.getFormattedDate(value, this.matrixModeToFormat[mode])
      : this.localizationUtils.getFormattedDate(value, 'dateTimeListFormat');
  }

}
@NgModule({
  declarations: [TakeAwayTimePipe],
  exports: [TakeAwayTimePipe],
})
export class TakeAwayTimePipeModule {}
